import { t } from '@transifex/native';

import * as flashActions from 'pkg/actions/flashes';

import * as endpoints from 'pkg/api/endpoints/auto';
import type * as models from 'pkg/api/models';
import * as sdk from 'pkg/core/sdk';

export interface IAddUsersPayload {
	userIDs: number[];
	sendInvites: boolean;
	organizer: {
		[key: number]: boolean;
	};
}

export const add = async (
	organizationId: number,
	id: number,
	payload: IAddUsersPayload
) => {
	const request = await sdk.post(
		endpoints.EventSeries.AddUsers(organizationId, id),
		{},
		payload
	);
	const response = await request.json();

	if (!response) {
		return;
	}
};

export interface UpdateEventSeriesUserPayload {
	userIDs: number[];
	status: models.eventSeriesUser.EventSeriesUserResponseStatus;
	role?: models.eventSeriesUser.EventSeriesUserRole;
}

export async function update(
	organizationId: number,
	eventSeriesId: number,
	payload: UpdateEventSeriesUserPayload
): Promise<[boolean, models.eventSeriesUser.EventSeriesUser[]]> {
	const req = await sdk.patch(
		endpoints.EventSeries.UpdateUsers(organizationId, eventSeriesId),
		{},
		payload
	);

	if (req.ok) {
		const resp = await req.json();

		return [true, resp];
	}

	const response = await req.json().catch(() => ({}));

	flashActions.show(
		{
			title: t('Could not update event series invite'),
			message: response?.error,
		},
		req.status
	);

	return [false, null];
}

export interface IUpdatePayload {
	userIDs: number[];
	status?: string;
	eventUsers?: models.eventUser.EventUser[];
}

export async function remove(
	organizationId: number,
	id: number,
	userIds: number[]
) {
	const request = await sdk.destroy(
		endpoints.EventSeries.RemoveUsers(organizationId, id),
		{},
		{ userIDs: userIds }
	);

	if (request.ok) {
		return true;
	}

	return false;
}
